import {useQuery} from '@tanstack/react-query'
import {toast} from 'react-toastify'

import useRequestParams from 'src/feature/bite/hook/request'

import {useParams} from 'react-router-dom'
import {MarketListSchemaResponse, ProductSchemaResponse} from '../domain'
import {useMarket} from '../hook'
import {API} from 'src/feature/bite/domain'

async function BasketCheckOrCreate(headers: any, auth: any) {
  const Response = await fetch(`${API}/Basket/SearchBasket`, {
    method: 'POST',
    headers,
    body: JSON.stringify({userID: auth()?.id}),
  })
  const Data = await Response.json()

  if (Data.response.basketId === null || Data.response.basketId === '') {
    const Response = await fetch(`${API}/Basket/CreateBasket`, {
      method: 'POST',
      headers,
      body: JSON.stringify({userID: auth()?.id}),
    })
    const Data = await Response.json()
    return Data.response.basketId
  }

  return Data.response.basketId
}

export function useGetList() {
  const {headers, errorMessage, signOut} = useRequestParams()
  const {listFilter, listFilterSet, listSet} = useMarket()

  return useQuery(
    ['market', listFilter],
    async () => {
      const Response = await fetch(`${API}/PortalProduct/List`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          ...listFilter,
        }),
      })

      if (Response.status === 401) {
        signOut()
      }

      const Data = await Response.json()

      const parse = MarketListSchemaResponse.parse(Data)

      listSet(parse.response)
      listFilterSet({
        ...listFilter,
        paging: {
          currentPageNumber: parse.response.paging.currentPageNumber,
          pageSize: parse.response.paging.pageSize,
        },
      })

      return true
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: false,
      onSuccess: () => {},
      onError: (error) => {
        toast.error(errorMessage, {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: 'light',
        })
      },
    }
  )
}

export function useGetDetail() {
  const {headers, errorMessage, signOut} = useRequestParams()
  const {detailSet} = useMarket()
  const {productId} = useParams()

  return useQuery(
    ['productMarket'],
    async () => {
      const Response = await fetch(`${API}/PortalProduct/GetDetail`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          productId,
        }),
      })

      if (Response.status === 401) {
        signOut()
      }

      const Data = await Response.json()

      const parse = ProductSchemaResponse.parse(Data)

      detailSet(parse.response)

      return true
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: false,
      onSuccess: () => {},
      onError: (error) => {
        toast.error(errorMessage, {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: 'light',
        })
      },
    }
  )
}

export function useGetBasket() {
  const {auth, headers, errorMessage, signOut} = useRequestParams()
  const {basketId, basketIdSet, basketSet} = useMarket()

  return useQuery(
    ['basket'],
    async () => {
      const id =
        basketId === '' || basketId === null ? await BasketCheckOrCreate(headers, auth) : basketId

      const Response = await fetch(`${API}/Basket/GetBasketDetails`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          userID: auth()?.id,
          basketId: id,
        }),
      })

      if (Response.status === 401) {
        signOut()
      }

      const Data = await Response.json()

      basketSet(Data.response)
      basketIdSet(id)

      return true
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: false,
      onSuccess: () => {},
      onError: (error) => {
        toast.error(errorMessage, {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: 'light',
        })
      },
    }
  )
}
